import { Butticon } from '@hopin-team/ui-butticon';
import { Flex } from '@hopin-team/ui-flex';
import { Grid } from '@hopin-team/ui-grid';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { Text } from '@hopin-team/ui-text';
import { rem } from 'polished';
import styled from 'styled-components';

import { BREAKPOINT_LARGE_WIDTH } from '../../constants';

export const ColumnOne = styled(Flex)<{ isMedium: boolean }>`
  flex-direction: column;
  justify-items: flex-start;
  align-items: flex-start;
  min-width: 200px;
  flex: 0 0 auto;

  ${({ isMedium }) => isMedium && `margin-bottom: 1rem`}
`;

export const ColumnTwo = styled(Flex)`
  width: 100%;
  flex-direction: column;
  justify-items: flex-start;
  align-items: flex-start;
`;

export const Title = styled(Text)`
  color: var(--color-schedule-title);
  font-size: ${rem(14)};
`;

export const TimeSplitter = styled.span`
  margin: 0 ${rem(4)};
`;

export const Segment = styled(Text)`
  color: var(--color-schedule-segment);
  font-weight: 500;
  font-size: ${rem(14)};
  max-width: 200px;
`;

export const VirtualSection = styled(Flex)`
  align-items: center;
  column-gap: ${rem(16)};
  flex-direction: row;
  margin-bottom: ${rem(12)};
  padding-bottom: ${rem(8)};
  border-bottom: ${rem(1)} solid
    ${({ theme }) => getFromTheme('COLOR.GREY.300', theme)};
`;

export const DayIncrement = styled(Text)`
  font-size: ${rem(13)};
`;

export const EmptyText = styled(Text)`
  text-align: center;
  max-width: ${rem(288)};
`;

export const Description = styled(Text)`
  color: var(--color-schedule-description);
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  white-space: pre-line;
`;

export const FullFlex = styled(Flex)`
  width: 100%;
`;

export const DescriptionSection = styled(Flex)`
  width: 100%;
  max-width: ${`${BREAKPOINT_LARGE_WIDTH}px`};
`;

export const Speakers = styled(Grid)<{ isMedium: boolean }>`
  width: 100%;
  max-width: ${`${BREAKPOINT_LARGE_WIDTH}px`};
  grid-template-columns: repeat(2, 1fr);
  ${({ isMedium }) => isMedium && `grid-template-columns: 1fr;`}
`;

export const MoreSpeakersButton = styled.button`
  margin-bottom: ${rem(12)};
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => getFromTheme('COLOR.THEME.PRIMARY', theme)};
  justify-self: left;
`;

export const TagsSection = styled(Flex)`
  max-width: 100%;
  flex-wrap: wrap;
`;

export const CustomSegmentIcon = styled.img`
  max-width: ${rem(22)};
  max-height: ${rem(13)};
  width: auto;
  height: auto;
  margin-right: ${rem(8)};
`;

export const Link = styled(Butticon)`
  border-bottom: none;
`;

export const NowOnBadge = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  border-radius: ${rem(24)};
  border: ${rem(2)} solid
    ${({ theme }) => getFromTheme('COLOR.GREY.WHITE', theme)};
  background-color: ${({ theme }) => getFromTheme('COLOR.RED.600', theme)};
  color: ${({ theme }) => getFromTheme('COLOR.GREY.WHITE', theme)};
  font-weight: 900;
  font-size: ${rem(8)};
  line-height: ${rem(12)};
  text-transform: uppercase;
  white-space: nowrap;
  padding: 0 ${rem(6)};
  margin: 0 ${rem(6)} 0 0;
`;

export const RenderAsHTML = styled.div`
  blockquote {
    overflow: hidden;
    padding-right: 1.5em;
    padding-left: 1.5em;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    border-left: 5px solid #ccc;
  }
  blockquote[dir='rtl'] {
    border-right: 5px solid #ccc;
  }

  ul,
  ol {
    padding-left: 1rem;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
`;

export const hybridTagStyling = {
  textColor: 'COLOR.GREY.700',
  backgroundColor: 'COLOR.GREY.100',
  height: 2.5,
  mr: 1,
};

export const SpeakerContainer = styled.div<{ link?: boolean }>`
  cursor: ${({ link }) => (link ? 'pointer' : 'auto')};
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${rem(8)};
`;
